const articleIdRegex = /\/(?:ece\d+|article\d+\.ece)(?:\/|$)/i
const externalUrlRegex = /^(http|https):\/\//

export function isArticleUrl(path: string): boolean {
  return articleIdRegex.test(path)
}

export function isExternalUrl(href: string): boolean {
  return externalUrlRegex.test(href)
}
